import React from "react";
import { Provider } from "./providers";

const App = () => {
  return <Provider />;
};

export default App;
